module.exports = __webpack_public_path__ + "img/icon-8.ea00b7b4.svg";